import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';

import Home from './components/Home';
import Information from './components/Information';
import Registration from './components/Registration';
import Status from './components/Status';
import NotFound from './components/NotFound';

Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

//import './styles/imports.styl';

Vue.use(VueRouter);
export const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/travel-booking/' : '/',
  routes: [
      { path: '/', component: Home },
      { path: '/information', component: Information },
      { path: '/registration', component: Registration },
      { path: '/status', component: Status },
      { path: '*', component: NotFound }
  ]
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
